module.exports = __webpack_public_path__ + "media/app/assets/classes/paladin-b7e2cf4d5d32b7786c31c21455e47154.jpg";